// Layout
// @ts-ignore
import { AuthLayout } from '@zolteam/zol-admin-ui';
// Views
import Home from '../views/Home';
import Login from '../views/auth/Login';
import ErrorFallback from '../views/ErrorFallback';
import CustomerList from '../views/customer/CustomerList';
import CustomerNew from '../views/customer/CustomerNew';
import ResetPassword from '../views/auth/ResetPassword';
import UpdatePassword from '../views/auth/UpdatePassword';
import BookingList from '../views/bookings/BookingList';
import BookingNew from '../views/bookings/BookingNew';
// Components
import ProtectedRoute from './ProtectedRoute';
import Layout from '../components/templates/Layout';
import SharedFlightBrief from '../views/sharedFlightBrief/SharedFlightBrief';
import FlightBriefNew from '../views/flightBrief/FlightBriefNew';
import AirportList from '../views/airports/AirportList';
import AirportNew from '../views/airports/AirportNew';
import TerminalNew from '../views/airports/terminals/TerminalNew';

/**
 *  @type {Route[]}
 */
const publicRoutes = [
  {
    path: '/login',
    element: <AuthLayout><Login /></AuthLayout>,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/reset-password',
    element: <AuthLayout><ResetPassword /></AuthLayout>,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/update-password',
    element: <AuthLayout><UpdatePassword origin="admin" /></AuthLayout>,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/update-password/worker',
    element: <AuthLayout><UpdatePassword origin="worker" /></AuthLayout>,
    errorElement: <ErrorFallback />,
  },
  {
    path: '/shared-flight-brief/:uuid',
    element: <SharedFlightBrief />,
    errorElement: <ErrorFallback />,
  },
];

/**
 *  @type {Route[]}
 */
const privateRoutes = [
  {
    element: <ProtectedRoute><Layout /></ProtectedRoute>,
    children: [
      {
        path: '/',
        element: <Home />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/customers',
        element: <CustomerList />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/customers/new',
        element: <CustomerNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/customers/:email',
        element: <CustomerNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/bookings',
        element: <BookingList />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/bookings/new',
        element: <BookingNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/bookings/:id',
        element: <BookingNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/bookings/:id/flight-brief',
        element: <FlightBriefNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/bookings/:id/flight-brief/:uuid',
        element: <FlightBriefNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/airports',
        element: <AirportList />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/airports/new',
        element: <AirportNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/airports/:id',
        element: <AirportNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/airports/:id/terminals/new',
        element: <TerminalNew />,
        errorElement: <ErrorFallback />,
      },
      {
        path: '/airports/:id/terminals/:terminalId',
        element: <TerminalNew />,
        errorElement: <ErrorFallback />,
      },
    ],
    errorElement: <ErrorFallback />,
  },
];

export default [
  ...publicRoutes,
  ...privateRoutes,
];
